import { Component, Input } from '@angular/core';

import { FileExt } from '~/models/document-finder.models';

const LABELS: Record<FileExt, string> = { docx: 'DOC', xlsx: 'XLS', pdf: 'PDF', pptx: 'PPT', bpmn: 'BPMN', svg: 'SVG' };

@Component({
    selector: 'df-file-badge',
    template: `<span class="ext" [ngClass]="ext" aria-hidden="true">{{ label }}</span>`,
    styleUrls: ['./df-file-badge.component.scss'],
    standalone: false
})
export class DfFileBadgeComponent {
    @Input() ext: FileExt = 'docx';

    public get label(): string {
        return LABELS[this.ext] ?? this.ext.toUpperCase();
    }
}
